import { NamedProperty } from "../types/NamedProperty";

interface Entity {
    id: string | number;
}

interface NamedEntity {
    id: string | number;
    name: string;
}

interface TitledEntity {
    id: string | number;
    title: string;
}

export const mapToNamedProperty = <T extends Entity | NamedEntity | TitledEntity>(
    value: T,
    renderName?: (value: T) => string
): NamedProperty => {
    if (renderName) {
        return {
            id: value.id.toString(),
            name: renderName(value)
        };
    }

    if (isNamedEntity(value)) {
        return {
            id: String(value.id),
            name: value.name
        };
    }

    if (isTitledEntity(value)) {
        return {
            id: String(value.id),
            name: value.title
        };
    }

    throw new Error("Value cannot be mapped to NamedProperty.");
};

const isNamedEntity = (value: unknown): value is NamedEntity => {
    return (
        typeof value === "object" &&
        value !== null &&
        Object.keys(value).includes("id") &&
        Object.keys(value).includes("name")
    );
};

const isTitledEntity = (value: unknown): value is TitledEntity => {
    return (
        typeof value === "object" &&
        value !== null &&
        Object.keys(value).includes("id") &&
        Object.keys(value).includes("title")
    );
};
